<template>
  <div class="h-7">
    <div class="h-7 fixed inset-y-0 w-full bg-fp-blue-6 text-sm z-50">
      <div class="max-w-7xl mx-auto py-1 px-3 sm:px-6 lg:px-8">
        <div
          class="sm:text-center sm:px-16 flex justify-center items-center gap-3"
        >
          <p class="text-white">
            <span>STAGING</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
